<template>
  <div class="blog">
    <h1>Blog</h1>
    <p>Welcome to my blog! I'll be documenting my thoughts and writing technical articles for things that I have learned. This is mainly for my own benifit but I hope a post or two will help someone else out at some point. :)</p>
    <TileRepeater :tile-items="tileItems" />
  </div>
</template>
<script>
import TileRepeater from '@/components/navigation/tile-repeater.vue'
import * as jacktearleapi from '@/api/api.jacktearle.dev.js'
import * as tileItemConverter from '@/utils/tile-itemconverter.js'

export default {
  name: 'blog',
  components: { TileRepeater },
  data () {
    return {
      posts: [],
      errors: [],
      tileItems: []
    }
  },
  created () {
    jacktearleapi
      .GetPosts()
      .then(response => {
        this.posts = response.data.posts
        this.posts.forEach(post => {
          this.tileItems.push(tileItemConverter.BlogPostToTileItem(post))
        })
      })
      .catch(e => {
        this.errors.push(e)
      })
  }
}
</script>
